export default __webpack_public_path__ + "static/media/kinui.3fc663df.webp";